import { ReferralQuestionKind } from '../referrals/referrals.enums';
import { SortDirection } from '../sort/sort.enums';

export interface ReferralsPortalApplicationPayloadI {
  cv?: string;
  email: string;
  name: string;
  offerId: number;
  phone?: string;
  referralConnectionId?: number;
  referralQuestionAnswers?: ReferralQuestionAnswer[];
  socialLinks: string[];
}

export interface ReferralQuestionAnswer {
  questionTitle: string;
  questionKind: ReferralQuestionKind;
  questionPosition: number;
  questionRequired: boolean;
  questionOptions: { title: string; position?: string }[];
  content?: string;
  contents?: string[];
}

export enum ReferralsPortalApplicationStatus {
  InReview = 'in_review',
  ProcessComplete = 'process_complete',
  Success = 'success',
}

export enum ReferralsPortalApplicationClaimStatus {
  Open = 'open',
  Rejected = 'rejeccted',
  Accepted = 'accepted',
}

export interface ReferralsPortalApplication {
  id: number;
  name: string;
  status: ReferralsPortalApplicationStatus;
  referralReward: ReferralReward;
  referralConnectionId: number;
  photoThumbUrl: string;
  offerTitle: string;
  createdAt: string;
  updatedAt: string;
  claimStatus: ReferralsPortalApplicationClaimStatus;
  referralStatus: string | null;
}

export interface ReferralsPortalApplicationParams {
  q?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
}

interface ReferralReward {
  bodyHtml: string;
  id: number;
  name: string;
  photoThumbUrl: string;
  photoUrl: string;
}
